/**
 * @generated SignedSource<<ff6c1c976d29a83ff18a9f4838c9283b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Difficulty = "beginner" | "easy" | "hard" | "moderate" | "%future added value";
export type Kind = "article" | "set" | "video" | "%future added value";
export type sourceEditQuery$variables = {
  backLang?: string | null;
  deckId?: string | null;
  id: string;
};
export type sourceEditQuery$data = {
  readonly node: {
    readonly contentTest?: {
      readonly active: boolean;
    } | null;
    readonly course?: boolean;
    readonly difficulty?: Difficulty;
    readonly duoLang?: boolean;
    readonly id?: string;
    readonly image?: {
      readonly url: string;
    } | null;
    readonly imageId?: string | null;
    readonly kind?: Kind;
    readonly lang?: string;
    readonly multiLang?: boolean;
    readonly name?: string;
    readonly nameRaw?: string | null;
    readonly natives?: ReadonlyArray<{
      readonly langNative: string;
      readonly nameNative: string;
    }>;
    readonly private?: boolean;
    readonly sCards?: ReadonlyArray<{
      readonly back: {
        readonly translated: boolean | null;
        readonly value: string;
      } | null;
      readonly front: string;
      readonly hint: string | null;
      readonly id: string;
      readonly isInMyDeck: boolean | null;
      readonly sourceId: string;
      readonly svg: {
        readonly flatId: string;
        readonly url: string;
      } | null;
      readonly theory: {
        readonly canEdit: boolean;
        readonly lang: string;
        readonly langNative: string;
        readonly sCardId: string;
        readonly theory: string;
        readonly theoryEn: string | null;
        readonly theoryIsChecked: boolean;
        readonly theoryNative: string;
        readonly theoryNativeIsChecked: boolean;
      } | null;
    }>;
    readonly source?: string | null;
    readonly text?: string | null;
    readonly uri?: string;
    readonly videoDuration?: number | null;
    readonly videoLang?: string | null;
    readonly videoStart?: number | null;
  } | null;
};
export type sourceEditQuery = {
  response: sourceEditQuery$data;
  variables: sourceEditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "backLang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deckId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uri",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameRaw",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "langNative",
    "variableName": "backLang"
  }
],
v8 = {
  "alias": null,
  "args": (v7/*: any*/),
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lang",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "multiLang",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "course",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duoLang",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "private",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "difficulty",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoStart",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoLang",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoDuration",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "langNative",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameNative",
  "storageKey": null
},
v25 = [
  {
    "kind": "Variable",
    "name": "backLang",
    "variableName": "backLang"
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "front",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hint",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "deckId",
      "variableName": "deckId"
    }
  ],
  "kind": "ScalarField",
  "name": "isInMyDeck",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "translated",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "SCardTheory",
  "kind": "LinkedField",
  "name": "theory",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sCardId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theory",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theoryIsChecked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theoryNative",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theoryNativeIsChecked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theoryEn",
      "storageKey": null
    },
    (v9/*: any*/),
    (v23/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canEdit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flatId",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentTestType",
  "kind": "LinkedField",
  "name": "contentTest",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "sourceEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Native",
                "kind": "LinkedField",
                "name": "natives",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v25/*: any*/),
                "concreteType": "SCard",
                "kind": "LinkedField",
                "name": "sCards",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SCardBack",
                    "kind": "LinkedField",
                    "name": "back",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      (v31/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Upload",
                    "kind": "LinkedField",
                    "name": "svg",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/),
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v34/*: any*/)
            ],
            "type": "Source",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "sourceEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Native",
                "kind": "LinkedField",
                "name": "natives",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v25/*: any*/),
                "concreteType": "SCard",
                "kind": "LinkedField",
                "name": "sCards",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SCardBack",
                    "kind": "LinkedField",
                    "name": "back",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Upload",
                    "kind": "LinkedField",
                    "name": "svg",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/),
                      (v22/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v34/*: any*/)
            ],
            "type": "Source",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "609268e8f887e6a1cdd01b68f6a0be9d",
    "id": null,
    "metadata": {},
    "name": "sourceEditQuery",
    "operationKind": "query",
    "text": "query sourceEditQuery(\n  $id: ID!\n  $backLang: String\n  $deckId: ID\n) {\n  node(id: $id) {\n    __typename\n    ... on Source {\n      id\n      uri\n      nameRaw\n      name(langNative: $backLang)\n      lang\n      multiLang\n      kind\n      course\n      text\n      source\n      duoLang\n      private\n      difficulty\n      videoStart\n      videoLang\n      videoDuration\n      imageId\n      image {\n        url\n        id\n      }\n      natives {\n        langNative\n        nameNative\n        id\n      }\n      sCards(backLang: $backLang) {\n        id\n        front\n        hint\n        sourceId\n        isInMyDeck(deckId: $deckId)\n        back {\n          value\n          translated\n          id\n        }\n        theory(langNative: $backLang) {\n          sCardId\n          theory\n          theoryIsChecked\n          theoryNative\n          theoryNativeIsChecked\n          theoryEn\n          lang\n          langNative\n          canEdit\n        }\n        svg {\n          flatId\n          url\n          id\n        }\n      }\n      contentTest {\n        active\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c979a58b53418b9e5d4cbf4c5e705913";

export default node;
